// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"MobileCancelProposalBody_modal_body__3Q_HK","footer":"MobileCancelProposalBody_footer__2cwtx"};